/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Go_To_Event_EndInputs */

const en_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go To End Of Event`)
};

const fr_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller a la fin de l'evenement`)
};

const de_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zum Ende der Veranstaltung`)
};

const it_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla fine dell'evento`)
};

const ru_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к концу мероприятия`)
};

const es_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al final del evento`)
};

const zh_cn2_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往活动结束`)
};

const ja_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの最後へ移動`)
};

const hi_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट के अंत में जाएं`)
};

const pt_pt2_shortcut_keys_name_go_to_event_end = /** @type {(inputs: Shortcut_Keys_Name_Go_To_Event_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o final do evento`)
};

/**
* | output |
* | --- |
* | "Go To End Of Event" |
*
* @param {Shortcut_Keys_Name_Go_To_Event_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_go_to_event_end = /** @type {((inputs?: Shortcut_Keys_Name_Go_To_Event_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Go_To_Event_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "de") return de_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "it") return it_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "es") return es_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_go_to_event_end(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_go_to_event_end(inputs)
	return en_shortcut_keys_name_go_to_event_end(inputs)
});